package com.arena_web.data.repository

import com.arena_web.data.api.PricingApi
import com.arena_web.data.dto.PricingDto
import com.arena_web.domain.repositories.PricingRepository

class PricingRepositoryImpl(private val pricingApi: PricingApi) : PricingRepository {

    override suspend fun getPricing(): Result<PricingDto> =
        apiCall { pricingApi.getPricing() }
}
